export default {
  'completeprofile.completeprofile': 'INIZIA IL PROCESSO DI PROFILO COMPLETO',
  'completeprofile.maintext':
    'Per completare gli elementi del tuo profilo e ottenere punti positivi, prova a completare il tuo profilo premendo Completa Profilo',
};
